import { useMutation } from "react-query";
import deleteFile from "../services/deleteFile";

const useDeleteFile = () => {
  return useMutation(["delete-file"], deleteFile);
};

export default useDeleteFile;
